import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core'
import { CardBrandEnum } from './gb-card-icon.models'

@Component({
  selector: 'gb-card-icon',
  templateUrl: './gb-card-icon.component.html',
  styleUrls: ['./gb-card-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class GbCardIconComponent {
  @Input({ required: true }) brand!: string
  @Input() darkTheme = false

  public cardBrand = CardBrandEnum

  hasIcon(brand: string): boolean {
    return !!Object.values(CardBrandEnum).includes(brand as CardBrandEnum)
  }
}
